/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /vise/packages/app-share/src/services/fetch-user-info/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { H5_CALL_PATH } from '@/constants/url';
import { FetchUserInfoReq, FetchUserInfoRsp, FetchUserInfoResult } from '@/types/services/fetch-user-info';

/**
 *
 * 获取用户信息
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export default async function fetchUserInfo(params: FetchUserInfoReq): Promise<FetchUserInfoRsp['person']| null> {
  const fetchConfig: AjaxConfig = {
    url: `${H5_CALL_PATH}/weishi/GetUserInfo`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    data: JSON.stringify({
      datalvl: 'ad',
      iChid: 0,
      person_id: params.personId,
    }),
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return null;
  try {
    const { request } = wslAjax;
    const res = await request<FetchUserInfoResult>(fetchConfig);
    return res?.data?.person || null;
  } catch (err) {
    console.error('接口fetchUserInfo出现了一些问题');
  }
  return null;
}
